exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-5a550ad4]{width:100%;margin:0;text-align:left}ul.notebooks li[data-v-5a550ad4]{list-style:none;width:100%;height:50px;padding:0 20px;background-color:#ddd;border-top:1px solid #fff;border-bottom:1px solid #999;line-height:50px;cursor:pointer}ul.notebooks li[data-v-5a550ad4]:hover{background-color:#eee}.notebook-date[data-v-5a550ad4]{float:right}.notebooks-message[data-v-5a550ad4]{margin:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a550ad4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Notebooks.vue
// module id = 178
// module chunks = 0